/* eslint-disable import/prefer-default-export */

const backgroundDict = {
    'main gradient': 'home',
    'green gradient': 'players',
    'transparent map': 'organizers',
    'teal gradient 1': 'protennis',
    'teal gradient 2': 'rankings',
};

export const getBackgroundClass = (contentSlices) => {
    let background;
    if (contentSlices && typeof contentSlices === 'object') {
        background = contentSlices.find(slice => slice.type === 'page_background');
    }
    if (background && background.background) {
        return `${backgroundDict[background.background]}-background`;
    }
    return '';
};
